module.exports = __webpack_public_path__ + "img/stick.ec540a99.png";